
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ServiceItemProps } from ".";
import { loading, update } from "store/service";
import { AppMessage } from "components";

interface ApiServiceUpdateInputProps extends ServiceItemProps {
}

type ApiServiceUpdateOutputProps = OutputBaseProps<{ item: ServiceItemProps; }, ApiServiceUpdateInputProps>

export const apiServiceUpdate = async (data: ApiServiceUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiServiceUpdateOutputProps>("/api/service/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};